import React from 'react';
import Table from 'react-bootstrap/Table';

const SpreadsTable = ({ 
  spreadsData, 
  bookLogos, 
  getBookLogoUrl,
  getTeamLogoUrl,
  getCellStyle,
  getTooltipText,
  onOddsClick,
  game,
  oddsCellStyle
}) => {
  const safeGame = { away: 'TBD', home: 'TBD', gameIDmlb: 'loading', ...game };

  if (!spreadsData || spreadsData.length === 0) {
    return null;
  }

  return (
    <div className="table-container">
      <Table bordered size="sm" className="text-center">
        <thead>
          <tr><th colSpan={bookLogos.length + 1} style={{ backgroundColor: 'transparent', color: 'rgb(245, 158, 11)', fontWeight: 'bold' }}>Spreads</th></tr>
          <tr>
            <th style={{ width: '120px' }}></th>
            {bookLogos.map(book => (
              <th key={`spreads-${book}`} style={oddsCellStyle}>
                <img 
                  src={getBookLogoUrl(book)} 
                  alt={`${book} logo`} 
                  title={book} 
                  style={{ height: '20px' }} 
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ width: '120px', fontWeight: 'bold' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                <img
                  src={safeGame.awayLogo || getTeamLogoUrl(safeGame.away)}
                  alt={safeGame.away}
                  style={{ width: '16px', height: '16px' }}
                  onError={(e) => {
                    e.target.style.visibility = 'hidden';
                    e.target.style.width = '0px';
                    e.target.style.height = '0px';
                    e.target.style.margin = '0px';
                  }}
                />
                <span>{safeGame.away}</span>
              </div>
            </td>
            {bookLogos.map(book => {
              // Find away and home spread data for this book
              const awayData = spreadsData.find(d => d.team === 'away' && d[`spreads_${book}`]);
              
              return (
                <td
                  key={`spreads-${book}-away`}
                  className="odds-cell"
                  style={{
                    ...getCellStyle(
                      awayData?.[`spreads_${book}`], 
                      awayData?.[`spreads_bestBookPrice`], 
                      awayData?.[`spreads_bestBookDiff`], 
                      bookLogos.filter(b => awayData?.[`spreads_${b}`] !== null && awayData?.[`spreads_${b}`] !== undefined).length,
                      awayData?.[`spreads_${book}_direction`]
                    ),
                    textAlign: 'center',
                    padding: '8px 4px',
                    fontSize: '0.8rem',
                    cursor: awayData ? 'pointer' : 'default'
                  }}
                  title={getTooltipText(
                    awayData?.[`spreads_${book}`], 
                    awayData?.[`spreads_bestBookPrice`], 
                    awayData?.[`spreads_bestBookDiff`], 
                    bookLogos.filter(b => awayData?.[`spreads_${b}`] !== null && awayData?.[`spreads_${b}`] !== undefined).length
                  )}
                  onClick={() => {
                    if (awayData && onOddsClick) {
                      onOddsClick(safeGame.gameIDmlb, null, safeGame.away, 'spreads', book, awayData[`spreads_${book}`], safeGame.away, safeGame.home, null, null, awayData.point > 0 ? `+${awayData.point}` : `${awayData.point}`, 'away', safeGame.awayTeamId);
                    }
                  }}
                >
                  {awayData ? (
                    <div>
                      <div style={{ fontWeight: 'bold' }}>{awayData[`spreads_${book}`] > 0 ? `+${awayData[`spreads_${book}`]}` : awayData[`spreads_${book}`]}</div>
                      <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>{awayData.point > 0 ? `+${awayData.point}` : awayData.point}</div>
                    </div>
                  ) : null}
                </td>
              );
            })}
          </tr>
          <tr>
            <td style={{ width: '120px', fontWeight: 'bold' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                <img
                  src={safeGame.homeLogo || getTeamLogoUrl(safeGame.home)}
                  alt={safeGame.home}
                  style={{ width: '16px', height: '16px' }}
                  onError={(e) => {
                    e.target.style.visibility = 'hidden';
                    e.target.style.width = '0px';
                    e.target.style.height = '0px';
                    e.target.style.margin = '0px';
                  }}
                />
                <span>{safeGame.home}</span>
              </div>
            </td>
            {bookLogos.map(book => {
              // Find home spread data for this book
              const homeData = spreadsData.find(d => d.team === 'home' && d[`spreads_${book}`]);
              
              return (
                <td
                  key={`spreads-${book}-home`}
                  className="odds-cell"
                  style={{
                    ...getCellStyle(
                      homeData?.[`spreads_${book}`], 
                      homeData?.[`spreads_bestBookPrice`], 
                      homeData?.[`spreads_bestBookDiff`], 
                      bookLogos.filter(b => homeData?.[`spreads_${b}`] !== null && homeData?.[`spreads_${b}`] !== undefined).length,
                      homeData?.[`spreads_${book}_direction`]
                    ),
                    textAlign: 'center',
                    padding: '8px 4px',
                    fontSize: '0.8rem',
                    cursor: homeData ? 'pointer' : 'default'
                  }}
                  title={getTooltipText(
                    homeData?.[`spreads_${book}`], 
                    homeData?.[`spreads_bestBookPrice`], 
                    homeData?.[`spreads_bestBookDiff`], 
                    bookLogos.filter(b => homeData?.[`spreads_${b}`] !== null && homeData?.[`spreads_${b}`] !== undefined).length
                  )}
                  onClick={() => {
                    if (homeData && onOddsClick) {
                      onOddsClick(safeGame.gameIDmlb, null, safeGame.home, 'spreads', book, homeData[`spreads_${book}`], safeGame.away, safeGame.home, null, null, homeData.point > 0 ? `+${homeData.point}` : `${homeData.point}`, 'home', safeGame.homeTeamId);
                    }
                  }}
                >
                  {homeData ? (
                    <div>
                      <div style={{ fontWeight: 'bold' }}>{homeData[`spreads_${book}`] > 0 ? `+${homeData[`spreads_${book}`]}` : homeData[`spreads_${book}`]}</div>
                      <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>{homeData.point > 0 ? `+${homeData.point}` : homeData.point}</div>
                    </div>
                  ) : null}
                </td>
              );
            })}
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default SpreadsTable;